export function fileSizeDisplay(size: any): string {
	const bytes = Number(size);
	if (bytes < 1000) {
		return `${Math.round(bytes)}b`;
	} else if (bytes < 1000000) {
		return `${Math.round(bytes / 100) / 10}Kb`;
	} else if (bytes < 1000000000) {
		return `${Math.round(bytes / 100000) / 10}MB`;
	}
	return `${bytes}`;
}
